import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { CurrencyFormView } from './currency-form.view';
import { CurrencyDataService } from './currency-form.data';
import { ConfigurationService } from 'src/core/services/configuration.service';

interface CurrencyFormParams {
	id: string
}

@observer
export class CurrencyFormController extends React.Component<ControllerProps<CurrencyFormParams>, any> {
	@observable
	protected dataService: CurrencyDataService;

	@resolve
	protected toast: ToastNotifications;

	@observable
	mode: ControlMode = 'display';

	@resolve
	protected configurationService: ConfigurationService;

	@observable
	defaultLanguaje: string;

	constructor(props) {
		super(props);
		this.dataService = CurrencyDataService.make();
	}

	@computed
	protected get title() {
		if (this.dataService && this.dataService.item && this.dataService.item.dynamicProperties.displayName) {
			return `Currency ${this.dataService.item.dynamicProperties['displayName'][this.defaultLanguaje]}`;
		}
		return '';
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.mode = mode;
	}

	@autobind
	protected create() {
		const tax = this.dataService.add(this.defaultLanguaje);
		return tax;
	}

	@autobind
	public async save() {
		const item = this.dataService.item;
		const errors = await item.validate(true);
		if (errors.length == 0) {
			this.props.setBusy(true);

			this.dataService.save()
				.then(() => {
					this.props.setBusy(false);
					this.onModeChanged('display');
					this.toast.showDataSaved();
					this.props.history.replace(`/general/currencies`);
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
		}
	}

	@autobind
	public cancel() {
		this.props.history.push('/general/currencies');
	}

	public componentDidMount() {
		this.props.setBusy(true);
		this.configurationService.current().then(res => {
			this.defaultLanguaje = res.defaultLanguage;
			if (this.props.match.params.id == 'new') {
				// Create new
				this.dataService.create(this.create)
					.then(() => {
						this.mode = 'edit';
						this.props.setBusy(false);
					}).catch(error => {
						this.props.setBusy(false);
						this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
					});
			} else {
				// Load entity
				this.dataService.addFilter('id', 'eq', this.props.match.params.id);
				this.dataService.addSorting('id', 'asc', true);
				this.dataService.pageSize = 1;
				this.dataService.load(query => query)
					.catch((error) => {
						this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
					})
					.then(() => {
						this.props.setBusy(false);
					});
			}
		});
	}

	public render() {
		return (
			<CurrencyFormView title={this.title}
				mode={this.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={this.dataService.item}
				setBusy={this.props.setBusy}
				contextService={this.dataService}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/currencies/form/currency-form.controller.tsx